import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { Picker as BasePicker } from '@react-native-picker/picker';
import { Text } from '@rneui/themed';
import { useTheme } from '../../../hooks';
export const Picker = ({ max, selected, label, onValueChange, }) => {
    const { colors } = useTheme();
    const [itemList, setItemList] = useState([]);
    useEffect(() => {
        const list = [];
        for (let i = 0; i <= max; i++) {
            list.push(i);
        }
        setItemList(list);
    }, [max]);
    return (React.createElement(View, { style: { alignItems: 'center' } },
        label && React.createElement(Text, { h2: true }, label),
        React.createElement(BasePicker, { style: { width: 120, height: 200 }, selectedValue: selected, onValueChange: (index) => onValueChange(index, selected || 0) }, itemList.map((value, i) => (React.createElement(BasePicker.Item, { label: `${value < 10 ? '0' : ''}${value}`, value: i, color: colors.textPrimary, key: i }))))));
};
//# sourceMappingURL=Picker.js.map